import useTheme from '@/utils/hooks/useTheme'
import { UserPreference } from '@/utils/hooks/useUserPreference'
import { useEffect } from 'react'

export default function ThemeService() {
	const [theme] = useTheme()
	const resetThemeClassName = () => {
		document.documentElement.classList.remove('jk-theme-light', 'jk-theme-dark')
	}

	const applyTheme = (nextTheme: UserPreference['theme']) => {
		switch (nextTheme) {
			case 'LIGHT':
				resetThemeClassName()
				document.documentElement.classList.add('jk-theme-light')
				break
			case 'DARK':
				resetThemeClassName()
				document.documentElement.classList.add('jk-theme-dark')
				break
			case 'AUTO':
				resetThemeClassName()
				break
		}
	}

	useEffect(() => {
		applyTheme(theme)
	}, [theme])

	return null
}
